import { render } from "./ShippingTC.vue?vue&type=template&id=f7acfdfe&scoped=true"
import script from "./ShippingTC.vue?vue&type=script&lang=js"
export * from "./ShippingTC.vue?vue&type=script&lang=js"

import "./ShippingTC.vue?vue&type=style&index=0&id=f7acfdfe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7acfdfe"]])

export default __exports__